import React from "react";
import Flags from "../Flags";
import "./MoneyConvertor.css";
import useMoney from "./talons/useMoney";
import percentage from "./../../images/percentage.webp";
import sum from "./../../images/sum.webp";
import equalsto from "./../../images/equalsto.webp";
import eurFlag from "./../../images/eur-flag.webp";
import Arrow from "../../images/Arrow Right.webp";
import { PillsHeader } from "../Home/PillsHeader";
import GatsbyImages from "../GatsbyImages";
import Select from "../Select";

export const MoneyConvertor = ({
  flagsPricingSendities,
  locationName,
  location,
  pills = false,
  lang,
  headerTextData,
  country_code,
}) => {
  const isEnLang = lang === "en";

  const {
    listcountries,
    countryHandlerMoney,
    countrySelectName,
    currencies,
    currencyHandlerMoney,
    selectCurrencies,
    agents,
    agentsHandlerMoney,
    selectAgents,
    txt,
    txtHandlerMoney,
    selecTtxt,
    handleMoneyInputChange,
    handleMoneyOutputChange,
    findInput,
    moneyInputFirst,
    moneyInputInRef,
    moneyInputOutRef,
    onSubmit,
    formError,
    errorMsg,
    txtRate,
    commisions,
    totalHelper,
    countrySelect,
  } = useMoney({
    flagsPricingSendities,
    country_code,
    isEnLang,
    location,
    lang,
  });

  const rootErrClass = formError ? "errorClass" : "noErrorClass";

  const dotsLoadingCondition = { display: moneyInputFirst ? "block" : "none" };

  const countryField = (
    <div className="flagsButton">
      <Flags
        lang={lang}
        flagsPricingSendities={flagsPricingSendities}
        customCss={locationName}
        isLink={locationName === "link"}
        country_code={countrySelect}
        countryHandler={countryHandlerMoney}
        countries={listcountries}
      />
    </div>
  );
  const currencyField =
    currencies.length > 1 ? (
      <Select
        name="country_foreign_exchange"
        onChange={currencyHandlerMoney}
        defaultValue={selectCurrencies}
        className="selectedCurrency"
        options={currencies}
      />
    ) : (
      <input
        type="text"
        className="selectedCurrency"
        value={selectCurrencies?.value || ""}
        readOnly
      />
    );

  const sucursalField =
    agents.length > 1 ? (
      <Select
        className={"exchangeAgency"}
        name="exchanges_agencies"
        defaultValue={selectAgents}
        onChange={agentsHandlerMoney}
        options={agents}
        isSearchable={true}
      />
    ) : (
      <input
        type="text"
        style={{ paddingLeft: "24px" }}
        className="exchangeAgency"
        value={selectAgents?.value || ""}
        readOnly
      />
    );

  const sucursalsComp = !agents.length ? (
    <div className="exchangeAgency">
      <div className="dot-flashing" />
    </div>
  ) : (
    sucursalField
  );

  const TXTtypeField =
    txt.length > 1 ? (
      <Select
        className={"TXType"}
        name="TXType"
        defaultValue={selecTtxt}
        onChange={txtHandlerMoney}
        options={txt}
        isSearchable={true}
      />
    ) : (
      <input
        style={{ paddingLeft: "24px" }}
        type="text"
        className="TXType"
        value={selecTtxt.label}
        readOnly
      />
    );

  const TXTtypeComp = !txt.length ? (
    <div className="TXType">
      <div className="dot-flashing" />
    </div>
  ) : (
    TXTtypeField
  );

  const cnTagConditions = (isEnLang, locationName) => {
    if (isEnLang && locationName === "remesas") {
      return "Remittances";
    }
    if (!isEnLang && locationName === "remesas") {
      return "Remesas";
    }
    if (isEnLang && locationName === "home") {
      return "Remittances";
    }
    if (!isEnLang && locationName === "home") {
      return "Remittances";
    }
  };

  const headerText = headerTextData
    ? headerTextData
    : lang === "es"
    ? "Envía tu dinero hoy con la mejor tasa de cambio"
    : "Send your money with the official market exchange rate";

  const headerTextElement = locationName !== "link" && (
    <h1 className="money-convertor_title">{headerText}</h1>
  );

  return (
    <main className="money-convertor_wrapper">
      <div className="money-convertor_header">
        <div className="cn_product_visited" style={{ display: "none" }}>
          <span className="url">{location}</span>
          <span className="category">
            {cnTagConditions(isEnLang, locationName)}
          </span>
          <span className="product_id">{countrySelectName}</span>
          <span className="custom_field_1">{selectCurrencies.value}</span>
          <span className="custom_field_2">{selectAgents.value}</span>
          <span className="custom_field_3">{selecTtxt.value}</span>
        </div>
        <div className="money-convertor_pill-wrapper">
          {pills && <PillsHeader lang={lang} />}
        </div>
        {headerTextElement}
      </div>
      <form className="moneyConvertor-formBody">
        <div className="control" style={dotsLoadingCondition}>
          <input
            defaultValue={moneyInputFirst}
            name="input-text"
            className="input-text"
            type="number"
            step=".01"
            placeholder=" "
            ref={moneyInputInRef}
            onChange={handleMoneyInputChange}
            onFocus={() => findInput("input-text")}
          />
          <label htmlFor="input-text">
            {isEnLang ? "I want to pay exactly" : "Quiero pagar exactamente"}
          </label>
          <div className="eur-flag-currency_wrapper">
            <span>EUR</span>
            <GatsbyImages
              src={eurFlag}
              alt="europe flag"
              height="14"
              width="21"
            />
          </div>
        </div>
        {moneyInputFirst ? null : (
          <div
            className="control dots"
            style={{
              display: moneyInputFirst ? "none" : "flex",
            }}
          >
            <div className="input-text" style={{ justifyContent: "start" }}>
              <div className="dot-flashing" />
            </div>
          </div>
        )}
        <div className="control" style={dotsLoadingCondition}>
          <input
            name="output-text"
            className="output-text"
            type="number"
            step=".01"
            placeholder=" "
            ref={moneyInputOutRef}
            onChange={handleMoneyOutputChange}
            onFocus={() => findInput("output-text")}
          />
          <label htmlFor="output-text">
            {isEnLang ? "Receive on arrival" : "Reciben en destino"}
          </label>
          <div className="flag-currency_wrapper-untouched">
            {currencyField}
            {countryField}
          </div>
        </div>
        {moneyInputFirst ? null : (
          <div
            className="control dots"
            style={{
              width: "296px",
              justifyItems: "center",
            }}
          >
            <div className="output-text">
              <div className="dot-flashing" />
              <div className="flag-currency_wrapper-loading">
                <div className="flagsButton-loading" />
              </div>
            </div>
          </div>
        )}
        <div className={rootErrClass}>
          <span className="errorField">{errorMsg}</span>
        </div>
        {TXTtypeComp}
        {sucursalsComp}
        <table className="data-table">
          <tbody>
            <tr>
              <th>
                <GatsbyImages
                  src={percentage}
                  alt="exchange rate"
                  height="18"
                  width="18"
                />
                <span>
                  {isEnLang
                    ? "Exchange rate applied"
                    : "Tasa de Cambio aplicada"}
                </span>
                <span>
                  {!!txtRate ? (
                    <>
                      1 € ={" "}
                      {txtRate.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })}{" "}
                      {selectCurrencies.value}
                    </>
                  ) : (
                    <div className="dot-flashing" />
                  )}
                </span>
              </th>
            </tr>
            <tr>
              <th>
                <GatsbyImages
                  src={sum}
                  alt="comissions"
                  height="18"
                  width="18"
                />
                <span>{isEnLang ? "Commissions" : "Comisiones"}</span>
                <span>
                  {commisions && commisions !== 0 ? (
                    `${Number(commisions).toFixed(2)} €`
                  ) : (
                    <div className="dot-flashing" />
                  )}
                </span>
              </th>
            </tr>
            <tr>
              <th>
                <GatsbyImages
                  src={equalsto}
                  alt="returns"
                  height="18"
                  width="18"
                />
                <span>
                  {isEnLang
                    ? "Amount we convert:"
                    : "Importe que convertimos: "}
                </span>
                <span>
                  {!!totalHelper && totalHelper !== 0 ? (
                    `${Number(totalHelper).toFixed(2)} €`
                  ) : (
                    <div className="dot-flashing" />
                  )}
                </span>
              </th>
            </tr>
          </tbody>
        </table>
        {locationName === "link" ? (
          <a
            className="sendButton"
            target="_blank"
            style={
              locationName === "remesas" || locationName === "link"
                ? { backgroundColor: "#24769D" }
                : { backgroundColor: "#123A4C" }
            }
            href={`https://payments.sendity.com/login?lang=${lang}`}
          >
            <span>{isEnLang ? "Start" : "Comenzar"}</span>
            <GatsbyImages src={Arrow} alt="go to payment.sendity" />
          </a>
        ) : (
          <button
            className="sendButton"
            style={
              locationName === "remesas" || locationName === "link"
                ? { backgroundColor: "#24769D" }
                : { backgroundColor: "#123A4C" }
            }
            type="button"
            onClick={onSubmit}
          >
            <span>{isEnLang ? "Start" : "Comenzar"}</span>
            <GatsbyImages src={Arrow} alt="go to payment.sendity" />
          </button>
        )}
      </form>
    </main>
  );
};
